const frequencies = {
  FREQUENCY_NONE: 'N' as EngineAPI.FrequencyModeType,
  FREQUENCY_VALUE: 'V' as EngineAPI.FrequencyModeType,
  FREQUENCY_PERCENT: 'P' as EngineAPI.FrequencyModeType,
  FREQUENCY_RELATIVE: 'R' as EngineAPI.FrequencyModeType,
};

export default frequencies;
